import {useCallback} from 'react';
import {getIsAgeRestricted} from '../../../../common/getIsAgeRestricted';
import {requestContext} from '../../../../common/requestContext';
import {CardViewItem} from '../../../../design-system/organisms/CardViewItem/CardViewItem';
import {
  CardSection as CardSectionType,
  CardViewItem as CardViewItemType,
  GroupType,
  SectionType,
} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT, LOG_SERIES_CLICK} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {useLogin} from '../../../../user/useLogin.hook';
import {CommonItemProps} from '../../type';

export function CardView({item, parentGroup, parentSection}: CommonItemProps) {
  const {
    thumbnail,
    badgeList,
    ageGradeBadge,
    statusBadge,
    subtitleList,
    scheme,
    eventLog,
    ageGrade,
    selfCensorship,
    rank,
    rankVariation,
    isEventBanner,
    categoryType,
    altText,
    title,
    discountRateText,
    backgroundColor,
    isBook,
    isLegacy,
  } = item as CardViewItemType;
  const {isMobile} = requestContext.requestInfo.display;
  const {user} = useLogin();

  const cardSection = parentSection as Omit<CardSectionType, 'groups'>;
  const isRecommendArea = cardSection.isRecommendArea;
  const isHelixThemeSection = cardSection.type === SectionType.HelixTheme;

  const inViewCallback = useCallback(
    (target: Element | undefined) => {
      aggregateAndSendLog({
        targetElem: target as HTMLElement,
        actionType: 'ViewImp',
        actionName: isHelixThemeSection ? '작품_노출' : '카드_노출',
        customProps: {
          user_action: 'imp',
        },
        ...(isHelixThemeSection && {
          viewimp_contents: {
            name: title,
          },
        }),
      });
    },
    [isHelixThemeSection, title]
  );

  return (
    <CardViewItem
      {...putTiaraObjectProps(eventLog)}
      onClickCapture={
        isEventBanner
          ? e => LOG_CLICK_EVENT('이벤트_클릭', e)
          : LOG_SERIES_CLICK
      }
      onInView={
        isRecommendArea
          ? target => {
              inViewCallback(target);
            }
          : undefined
      }
      categoryType={categoryType}
      thumbnail={thumbnail}
      badgeList={badgeList}
      statusBadge={statusBadge}
      ageGradeBadge={ageGradeBadge}
      subtitleList={subtitleList}
      cardViewTitle={title}
      backgroundColor={backgroundColor}
      isBook={isBook}
      isLegacy={isLegacy}
      scheme={scheme}
      imageLazyLoad={false}
      isAgeRestricted={getIsAgeRestricted({
        age: user?.age,
        authenticatedAt: user?.authenticatedAt,
        ageGrade,
        selfCensorship,
      })}
      rank={rank}
      rankVariation={rankVariation}
      altText={altText}
      className={
        parentGroup.type === GroupType.HorizontalScroll
          ? isMobile
            ? 'w-118pxr'
            : 'w-151.83pxr'
          : ''
      }
      discountRateText={discountRateText}
    />
  );
}
